import { render, staticRenderFns } from "./CallQueueBar.vue?vue&type=template&id=ff18dc52&scoped=true"
import script from "./CallQueueBar.vue?vue&type=script&lang=ts"
export * from "./CallQueueBar.vue?vue&type=script&lang=ts"
import style0 from "./CallQueueBar.vue?vue&type=style&index=0&id=ff18dc52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff18dc52",
  null
  
)

export default component.exports